import api from "@/lib/api";

function H() {
  const c = document.cookie.split(";").map(x=>x.trim()).find(x=>x.startsWith("active_hotel_id="));
  const v = c ? decodeURIComponent(c.split("=")[1]) : null;
  return { headers: v ? { "X-Hocp-Hotel": v } : {} };
}

export const guestAPI = {
  dashboard:    () => api.get("/guest/v1/dashboard", H()).then(r=>r.data),
  list:         (params={}) => api.get("/guest/v1/guests", { ...H(), params }).then(r=>r.data),
  create:       (b) => api.post("/guest/v1/guests", b, H()).then(r=>r.data),
  get:          (id) => api.get(`/guest/v1/guests/${id}`, H()).then(r=>r.data),
  update:       (id, b) => api.patch(`/guest/v1/guests/${id}`, b, H()).then(r=>r.data),
  blacklist:    (id, b) => api.post(`/guest/v1/guests/${id}/blacklist`, b, H()).then(r=>r.data),
  unblacklist:  (id) => api.delete(`/guest/v1/guests/${id}/blacklist`, H()).then(r=>r.data),

  stays:        (id) => api.get(`/guest/v1/guests/${id}/stays`, H()).then(r=>r.data),
  createStay:   (b) => api.post("/guest/v1/stays", b, H()).then(r=>r.data),
  updateStay:   (id, b) => api.patch(`/guest/v1/stays/${id}`, b, H()).then(r=>r.data),

  documents:    (id) => api.get(`/guest/v1/guests/${id}/documents`, H()).then(r=>r.data),
  addDoc:       (id, b) => api.post(`/guest/v1/guests/${id}/documents`, b, H()).then(r=>r.data),
  delDoc:       (gid, did) => api.delete(`/guest/v1/guests/${gid}/documents/${did}`, H()).then(r=>r.data),

  communications:(id) => api.get(`/guest/v1/guests/${id}/communications`, H()).then(r=>r.data),
  addComm:      (id, b) => api.post(`/guest/v1/guests/${id}/communications`, b, H()).then(r=>r.data),

  complaints:   (id) => api.get(`/guest/v1/guests/${id}/complaints`, H()).then(r=>r.data),
  addComplaint: (id, b) => api.post(`/guest/v1/guests/${id}/complaints`, b, H()).then(r=>r.data),
  updateComplaint:(cid, b) => api.patch(`/guest/v1/complaints/${cid}`, b, H()).then(r=>r.data),

  loyalty:      (id) => api.get(`/guest/v1/guests/${id}/loyalty`, H()).then(r=>r.data),
  adjustLoyalty:(id, b) => api.post(`/guest/v1/guests/${id}/loyalty/adjust`, b, H()).then(r=>r.data),

  relations:    (id) => api.get(`/guest/v1/guests/${id}/relations`, H()).then(r=>r.data),
  addRelation:  (id, b) => api.post(`/guest/v1/guests/${id}/relations`, b, H()).then(r=>r.data),
  delRelation:  (gid, rid) => api.delete(`/guest/v1/guests/${gid}/relations/${rid}`, H()).then(r=>r.data),

  companies:    (params={}) => api.get("/guest/v1/companies", { ...H(), params }).then(r=>r.data),
  createCompany:(b) => api.post("/guest/v1/companies", b, H()).then(r=>r.data),
  updateCompany:(id, b) => api.patch(`/guest/v1/companies/${id}`, b, H()).then(r=>r.data),

  timeline:     (id) => api.get(`/guest/v1/guests/${id}/timeline`, H()).then(r=>r.data),
  audit:        (id) => api.get(`/guest/v1/guests/${id}/audit`, H()).then(r=>r.data),
  analytics:    (id) => api.get(`/guest/v1/guests/${id}/analytics`, H()).then(r=>r.data),

  // GUEST-1 · cross-module 360 aggregations
  dining:       (id) => api.get(`/guest/v1/guests/${id}/dining`, H()).then(r=>r.data),
  housekeeping: (id) => api.get(`/guest/v1/guests/${id}/housekeeping`, H()).then(r=>r.data),
  maintenance:  (id) => api.get(`/guest/v1/guests/${id}/maintenance`, H()).then(r=>r.data),
  wallet:       (id) => api.get(`/guest/v1/guests/${id}/wallet`, H()).then(r=>r.data),
};

export const VIP_STYLE = {
  standard: "bg-slate-100 text-slate-600",
  silver:   "bg-slate-200 text-slate-800",
  gold:     "bg-amber-100 text-amber-800",
  platinum: "bg-violet-100 text-violet-800",
};

export const cls = "w-full h-10 px-3 rounded-lg border border-slate-200 bg-white text-[13px] outline-none focus:border-hocp-navy transition";

export function fmtDT(v) {
  if (!v) return "—";
  try { return new Date(v).toLocaleString([], { month:"short", day:"numeric", hour:"2-digit", minute:"2-digit" }); }
  catch { return "—"; }
}
export function fmtD(v) {
  if (!v) return "—";
  try { return new Date(v).toLocaleDateString([], { month:"short", day:"numeric", year:"numeric" }); }
  catch { return "—"; }
}
export function fmtINR(n) {
  if (n == null) return "—";
  return `₹${Number(n).toLocaleString("en-IN")}`;
}
export function initials(g) {
  const f = (g?.first_name || "").charAt(0);
  const l = (g?.last_name  || "").charAt(0);
  return (f + l).toUpperCase() || "?";
}
